module.exports = __webpack_public_path__ + "img/denmark.8729e003.png";